import { Link } from 'react-router-dom';
import { quickCategories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-600">
              Categories
            </span>
            <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">电影分类</h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              按类型快速进入，结合年代与国家筛选，定位你想看的作品
            </p>
          </div>
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {quickCategories.map((cat, i) => (
            <Link
              key={cat.name}
              to={`/category?genre=${encodeURIComponent(cat.query)}`}
              className="group animate-fade-up flex flex-col items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-0.5 hover:border-primary-300"
              style={{ animationDelay: `${i * 50}ms` }}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="text-sm font-semibold text-foreground-950">{cat.name}</h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}